import type { FindingEntry } from '@/api/types'

export function getDaysUntilExpiry(f: FindingEntry): number | null {
  const cp = f.crypto_properties?.certificateProperties
  if (cp?.daysUntilExpiry !== undefined) return cp.daysUntilExpiry
  const dateStr = cp?.notAfter ?? cp?.notValidAfter
  if (!dateStr) return null
  return Math.floor((new Date(dateStr).getTime() - Date.now()) / 86_400_000)
}
